import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        
        {/* Left side - About */}
        <div className="about-section">
          <img src="nrks-logo.png" alt="About Us" className="footer-logo" />
          <p className="about-text">
            NRKS Skill Development Pvt. Ltd. is committed to empowering individuals
            through industry-relevant training and career development programs. We aim to
            bridge the gap between education and employment by providing high-quality
            skill enhancement courses and internships.
          </p>

          <h3 className="section-title">Stay Updated with NRKS</h3>
          <form className="newsletter-form">
            <input type="email" placeholder="Enter Email..." className="email-input" />
            <p className="subscribe-text">
              *Subscribe to receive updates on new courses, internships, and career tips.
            </p>
          </form>
        </div>

        {/* Right side - Links + Social */}
        <div className="links-and-social">
          <div className="links-wrapper">
            <div className="section">
              <h3 className="section-title">Company</h3>
              <ul className="link-list">
                <li><a href="/">Home</a></li>
                <li><a href="/services">Services</a></li>
                <li><a href="/community">Community</a></li>
                <li><a href="/testimonies">Testimonies</a></li>
              </ul>
            </div>

            <div className="section">
              <h3 className="section-title">Support</h3>
              <ul className="link-list">
                <li><a href="/help">Help Center</a></li>
                <li><a href="/contact">Message Us</a></li>
                <li><a href="/webinars">Webinars</a></li>
                <li><a href="/feedback">Feedback</a></li>
              </ul>
            </div>

            <div className="section">
              <h3 className="section-title">Links</h3>
              <ul className="link-list">
                <li><a href="/courses">Courses</a></li>
                <li><a href="/internships">Internships</a></li>
                <li><a href="/instructor">Become an Instructor</a></li>
                <li><a href="/all">All</a></li>
              </ul>
            </div>
          </div>

          {/* Social icons */}
          <div className="social-icons">
            <a href="#">🌐</a>
            <a href="#">📘</a>
            <a href="#">📸</a>
            <a href="#">🐦</a>

            
          </div>
        </div>
      </div>

      {/* Bottom copyright */}
      <div className="footer-bottom">
        <p>
          © 2025 NRKS Skill Development Pvt. Ltd. | All Rights Reserved |
          <a href="/privacy"> Privacy Policy</a> |
          <a href="/terms"> Terms & Conditions</a>
        </p>
      </div>
    </footer>
  );
}
